import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-l pb-xs border-gray-200 border-b-2 flex items-center justify-between overflow-y-scroll" }
const _hoisted_2 = { class: "flex justify-end items-end" }

import RoundedCard from "@/components/RoundedCard.vue";
import { ref } from "vue";

import UmanaHeadline from "@/components/UmanaHeadline.vue";
import IconButton from "@/components/IconButton.vue";
import DialogCard from "@/components/DialogCard.vue";
import OrderMedicationFavorites from "@/modules/Orders/components/OrderMedicationFavorites.vue";
import EmptyContainer from "@/components/EmptyContainer.vue";
import SmallTag from "@/components/SmallTag.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FavoritesCard',
  setup(__props) {

const showFavoriteSettings = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RoundedCard, { class: "max-h-card" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(UmanaHeadline, { h: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode("Meine Produkte")
            ]),
            _: 1
          }),
          _createVNode(IconButton, {
            icon: "pen",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showFavoriteSettings.value = true))
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SmallTag, {
            small: "",
            color: "blue"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Beta")
            ]),
            _: 1
          })
        ]),
        _createVNode(EmptyContainer, null, {
          default: _withCtx(() => [
            _createTextVNode("Fügen Sie Produkte zu den Favoriten hinzu, um diese in Bestellungen schnell zu finden. Die Favoritenliste wird mit all Ihren Mitarbeiter:innen synchronisiert.")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(DialogCard, {
      color: "gray",
      "is-visible": showFavoriteSettings.value,
      "show-footer": false,
      title: "Meine Produkte",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (showFavoriteSettings.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(OrderMedicationFavorites, {
          "hide-plus": true,
          "show-search": true
        })
      ]),
      _: 1
    }, 8, ["is-visible"])
  ], 64))
}
}

})